import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    action: '',
    has_access: false,
    initialized: false,
    user_menu_state: 'loading',
    user: null,
    reader_assets: null,
    access_token: null,
    links: null
};

export const readerSlice = createSlice({
    name: 'reader',
    initialState,
    reducers: {
        setFromPaywallResponse: (state, action) => {
            state.initialized = true;
            state.action = action.payload.action || '';
            state.has_access = action.payload.has_access || false;
            state.user_menu_state = action.payload.user_menu_state || 'loading';
            state.user = action.payload.user || null;
            state.reader_assets = action.payload.reader_assets || null;
            state.links = action.payload.links || null;
            state.access_token = action.payload.access_token || null;   
        },
    }
});

export const { setFromPaywallResponse } = readerSlice.actions;

export default readerSlice.reducer;
